import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'

import Icon from 'discada/dist/Icon'

import PricingCard from 'components/VRP/PricingCard'
import Header from 'components/VRP/Header'
import { DirtyButton } from 'components/widgets/Dirty'
import { getValidModes } from 'selectors/quoteSelectors'

export function PricingCardFloater(props) {
  let { className, mode, vehicleId, dirty, okModes } = props

  return (
    <div className={c('pricing-card-floater', className, { dirty })}>
      <Header id={vehicleId} />

      <div className="pricing-cards-wrapper">
        {dirty ? (
          <DirtyButton {...props} size="small" />
        ) : (
          Object.keys(okModes)
            .map(k => {
              if (!okModes[k]) return null

              let selected = mode === k

              return (
                <PricingCard
                  {...props}
                  key={k}
                  mode={k}
                  selected={selected}
                  mini
                  toggle
                />
              )
            })
            .filter(x => x)
        )}
        <small className="mobile-callout">
          <Icon icon="hand-pointer" />
          Select your Payment!
        </small>
      </div>
    </div>
  )
}

function mapStateToProps(state, op) {
  return { ...op, okModes: getValidModes(state, op.vehicleId, op.quoteId) }
}

export default connect(mapStateToProps)(PricingCardFloater)
